import { uniqueId } from '@nextgen-web-framework/core';
import styles from './HowToSection.module.scss';
import { HowToSectionProps } from './types/propsTypes';

const HowToSection = (props: HowToSectionProps) => (
  <div className={styles['how-to-container']}>
    <div className={styles['how-to-title']}>{props.title}</div>
    <div className={styles['how-to-list']}>
      {props.howToList?.map((item, index) => (
        <div className={styles['how-to-item']} key={uniqueId()}>
          <div className={styles['how-to-item-count-container']}>
            <div className={styles['how-to-item-count']}>{index + 1}</div>
          </div>
          <div className={styles['how-to-item-content']}>
            <div className={styles['how-to-item-title']}>{item.question}</div>
            <div className={styles['how-to-item-subtitle']}>{item.answer}</div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default HowToSection;
